import { useTranslation } from 'react-i18next';
import { useParams, NavLink } from 'react-router-dom';
import "../../src/styles/sidebar/sidebar.css";
import DocInfoCard from './documents/DocInfoCard';
import { useAuth } from './context/AuthContext';
import { Roles } from '../roles';
import TopButton from './TopButton';
import ProfileAvatar from './users/UserProfile';
export default function DashboardSidebar(
    {
        uploadedFiles,
        totalSizeMB,
        maxSize,
        showMenu,
        setShowMenu
    }
) {
    const { user, role, isAuthenticated, logout } = useAuth();
    const { t } = useTranslation();
    const { lang } = useParams();
    const username = user?.userName;
    const calculatedTotalSizeMB = uploadedFiles?.filter(f => f.completed).reduce((sum, file) => sum + file.fileSize, 0) / (1024 * 1024);

    return (
        <>
            <div className={`sidebar ${showMenu ? "open" : ""}`}>
                <button className="sidebar-close-button" onClick={() => setShowMenu(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 16 16"><path fill="currentColor" fillRule="evenodd" d="M3.22 7.595a.75.75 0 0 0 0 1.06l3.25 3.25a.75.75 0 0 0 1.06-1.06l-2.72-2.72l2.72-2.72a.75.75 0 0 0-1.06-1.06zm8.25-3.25l-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25a.75.75 0 1 0 1.06-1.06l-2.72-2.72l2.72-2.72a.75.75 0 0 0-1.06-1.06" clipRule="evenodd"></path></svg>
                </button>



                <div className="top-part">

                    {isAuthenticated && (
                        <>
                            <div className="profile-settings">
                                <div className="profile-img">
                                    <ProfileAvatar user={user} active currentUser={user?.userName} />
                                </div>

                                <div className="profile-info">
                                    <h2 className="profile-name">{user?.userName}</h2>
                                    <span className="profile-email">{user?.email}</span>

                                </div>
                            </div>
                            <NavLink
                                to={`/lang/${lang}/upload`}
                                className={({ isActive }) =>
                                    `add-button ${isActive ? "active" : ""}`
                                }
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4.75c.69 0 1.25.56 1.25 1.25v4.75H18a1.25 1.25 0 1 1 0 2.5h-4.75V18a1.25 1.25 0 1 1-2.5 0v-4.75H6a1.25 1.25 0 1 1 0-2.5h4.75V6c0-.69.56-1.25 1.25-1.25" /></svg>
                                <span>{t("add-doc")}</span>
                            </NavLink>

                            <TopButton
                                to={`/lang/${lang}/admin/dashboard`}
                                icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M18.5 17.8v-2.3q0-.2-.15-.35T18 15t-.35.15t-.15.35v2.3q0 .2.075.375t.225.325l1.525 1.525q.15.15.35.15t.35-.15t.15-.35t-.15-.35zM5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v5q0 .425-.288.713T20 11t-.712-.288T19 10V5H5v14h5q.425 0 .713.288T11 20t-.288.713T10 21zm0-3v1V5v6.075V11zm2-2q0 .425.288.713T8 17h2.075q.425 0 .713-.288t.287-.712t-.287-.712t-.713-.288H8q-.425 0-.712.288T7 16m0-4q0 .425.288.713T8 13h5q.425 0 .713-.288T14 12t-.288-.712T13 11H8q-.425 0-.712.288T7 12m0-4q0 .425.288.713T8 9h8q.425 0 .713-.288T17 8t-.288-.712T16 7H8q-.425 0-.712.288T7 8m11 15q-2.075 0-3.537-1.463T13 18t1.463-3.537T18 13t3.538 1.463T23 18t-1.463 3.538T18 23" />
                                    </svg>
                                }
                                label={t("dashboard")}
                            />

                            {(role === Roles.ADMIN || role === Roles.SUPERADMIN) && (
                                <>
                                    {/* <TopButton
                                        to={`/lang/${lang}/admin/dashboard`}
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M18.5 17.8v-2.3q0-.2-.15-.35T18 15t-.35.15t-.15.35v2.3q0 .2.075.375t.225.325l1.525 1.525q.15.15.35.15t.35-.15t.15-.35t-.15-.35zM5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v5q0 .425-.288.713T20 11t-.712-.288T19 10V5H5v14h5q.425 0 .713.288T11 20t-.288.713T10 21zm0-3v1V5v6.075V11zm2-2q0 .425.288.713T8 17h2.075q.425 0 .713-.288t.287-.712t-.287-.712t-.713-.288H8q-.425 0-.712.288T7 16m0-4q0 .425.288.713T8 13h5q.425 0 .713-.288T14 12t-.288-.712T13 11H8q-.425 0-.712.288T7 12m0-4q0 .425.288.713T8 9h8q.425 0 .713-.288T17 8t-.288-.712T16 7H8q-.425 0-.712.288T7 8m11 15q-2.075 0-3.537-1.463T13 18t1.463-3.537T18 13t3.538 1.463T23 18t-1.463 3.538T18 23" /></svg>
                                        }
                                        label={t("dashboard")}
                                    /> */}
                                    <TopButton
                                        to={`/lang/${lang}/admin/user-manager`}
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M13.07 10.41a5 5 0 0 0 0-5.82A3.4 3.4 0 0 1 15 4a3.5 3.5 0 0 1 0 7a3.4 3.4 0 0 1-1.93-.59M5.5 7.5A3.5 3.5 0 1 1 9 11a3.5 3.5 0 0 1-3.5-3.5m2 0A1.5 1.5 0 1 0 9 6a1.5 1.5 0 0 0-1.5 1.5M16 17v2H2v-2s0-4 7-4s7 4 7 4m-2 0c-.14-.78-1.33-2-5-2s-4.93 1.31-5 2m11.95-4A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4Z" /></svg>}
                                        label={t("user")}
                                    />
                                    <TopButton
                                        to={`/lang/${lang}/admin/doc-manager`}
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M13 3v7h7M6 7H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1M8 4v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.389a1 1 0 0 0-.263-.676l-4.94-5.389A1 1 0 0 0 14.06 3H9a1 1 0 0 0-1 1Z" /></svg>
                                        }
                                        label={t("doc")}
                                    />

                                </>
                            )}

                            <TopButton
                                to={`/lang/${lang}/files/${username}`}
                                icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18v-6m0 0l-3 2m3-2l3 2M13 3H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h7.606c1.118 0 1.677 0 2.104-.218c.377-.192.683-.498.875-.874c.218-.428.218-.986.218-2.104V9m-6-6c.286.003.466.014.639.055q.308.075.578.24c.202.124.375.297.72.643l3.126 3.125c.346.346.518.518.642.72q.165.271.24.578c.04.173.051.354.054.639M13 3v2.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h2.802m0 0H19" /></svg>
                                }
                                label={t("uploaded-doc")}
                            />

                        </>
                    )}

                    <DocInfoCard totalFiles={uploadedFiles?.filter(f => f.completed).length} totalSize={calculatedTotalSizeMB} maxSize={maxSize} />
                </div>

                <div className="info-part">
                    <button className="btn-logout" onClick={logout}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z" /><path fill="currentColor" d="M15 11.25a.75.75 0 0 1 0 1.5H4.027l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 1 1 .976 1.14l-1.96 1.68z" /></svg>
                        <span>{t("logout")}</span>
                    </button>
                    <div className="power">
                        <span>  {t('creator')}</span>
                        <a href="/" target="_blank" rel="noopener noreferrer">
                            <img src="/assets/MPTC-MRD-2023_Subtitle-Blue.png" alt="MPTC Logo" className="logo" />
                        </a>
                    </div>
                </div>
            </div >
        </>


    );
};

